import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
export function HeroSection() {
  return <section className="relative overflow-hidden bg-gradient-to-b from-amber-50 via-amber-50/50 to-white pt-12 pb-10 lg:pt-20 lg:pb-16" data-id="element-229">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-230">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-10" data-id="element-231">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="flex-1 text-center lg:text-left max-w-2xl mx-auto lg:mx-0" data-id="element-232">
            <span className="inline-flex items-center px-4 py-1.5 rounded-full text-sm font-bold bg-amber-100 text-amber-700 mb-6 border border-amber-200 shadow-sm" data-id="element-233">
              📚 Ebook para padres y madres
            </span>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-stone-900 leading-tight mb-6 tracking-tight" data-id="element-234">
              ¿Y si el problema{' '}
              <span className="text-amber-500" data-id="element-235">no fuera tu hijo?</span>
            </h1>

            <p className="text-xl sm:text-2xl text-stone-600 mb-8 font-medium leading-relaxed" data-id="element-236">
              No necesitas gritar menos. Necesitas pedir diferente.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start mb-6" data-id="element-237">
              <button onClick={() => document.getElementById('precio')?.scrollIntoView({
              behavior: 'smooth'
            })} className="w-full sm:w-auto px-8 py-4 bg-amber-500 hover:bg-amber-600 text-white text-lg font-bold rounded-full shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300 flex items-center justify-center gap-2 group" data-id="element-238">
                Descargar y empezar hoy
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-239" />
              </button>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-x-6 gap-y-2 text-sm text-stone-500 font-medium" data-id="element-240">
              <span className="flex items-center gap-1.5" data-id="element-241">
                <CheckCircle2 className="w-4 h-4 text-emerald-500" data-id="element-242" />
                Rutinas visuales (mañana/tarde/noche)
              </span>
              <span className="flex items-center gap-1.5" data-id="element-243">
                <CheckCircle2 className="w-4 h-4 text-emerald-500" data-id="element-244" />
                Tablero Primero–Después para transiciones
              </span>
              <span className="flex items-center gap-1.5" data-id="element-245">
                <CheckCircle2 className="w-4 h-4 text-emerald-500" data-id="element-246" />
                Plan 14 días + plantillas listas
              </span>
            </div>
          </motion.div>

          {/* Image Content */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9,
          rotate: -2
        }} animate={{
          opacity: 1,
          scale: 1,
          rotate: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="flex-1 relative" data-id="element-247">
            <div className="relative z-10 max-w-sm mx-auto" data-id="element-248">
              <div className="absolute -inset-4 bg-amber-200/50 rounded-full blur-3xl opacity-70 animate-pulse" data-id="element-249"></div>
              <img src="https://cdn.magicpatterns.com/uploads/t1wXzLcq8WZedHxAGtdQB2/ChatGPT_Image_3_mar_2026,_10_55_20_p.m..png" alt="Sistema completo Rutinas Visuales sin Gritos" className="relative w-full h-auto rounded-xl shadow-2xl transform hover:scale-105 transition-transform duration-500" data-id="element-250" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}